<script setup lang="ts">
const { t } = useI18n()
const { state, onConfirm, onCancel } = useConfirm()
</script>

<template>
  <UModal
    v-model:open="state.open"
    :title="state.title"
    :ui="{ footer: 'justify-end' }"
    @close="onCancel"
  >
    <template #body>
      <p class="text-sm ui-text-subtle">{{ state.message }}</p>
    </template>
    <template #footer>
      <UButton color="neutral" variant="outline" @click="onCancel">
        {{ t('button.cancel') }}
      </UButton>
      <UButton color="error" @click="onConfirm">
        {{ state.confirmLabel ?? t('button.confirm') }}
      </UButton>
    </template>
  </UModal>
</template>
